// extracted by mini-css-extract-plugin
export var article = "articles-module--article--WVb7n";
export var container = "articles-module--container--pesRN";
export var link = "articles-module--link--Kcgv+";
export var selectedArticle = "articles-module--selectedArticle--mT2um";
export var selectedLink = "articles-module--selectedLink--HSdfC";